import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { parseISO, format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { toggleBigWidget } from '../DashboardSlice'
import { BigWidgetsName } from '../types'
import { WidgetWrapper } from '../widgetsComponents'

export const TopPerformance: FC = () => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()
  const dispatch = useAppDispatch()

  const { widgetsData, bigWidgetsList } = useAppSelector(({ dashboard }) => dashboard)

  const mostActiveSession = widgetsData?.topPerformance?.mostActiveSession
    ? format(parseISO(widgetsData.topPerformance.mostActiveSession), 'dd/MM/yyyy')
    : '-'

  const mostProfitableSession = widgetsData?.topPerformance?.mostProfitableSession
    ? format(parseISO(widgetsData.topPerformance.mostProfitableSession), 'dd/MM/yyyy')
    : '-'

  const leastProfitableSession = widgetsData?.topPerformance?.leastProfitableSession
    ? format(parseISO(widgetsData.topPerformance.leastProfitableSession), 'dd/MM/yyyy')
    : '-'

  const handleCheck = () => {
    dispatch(toggleBigWidget(BigWidgetsName.topPerformance))
  }

  return (
    <WidgetWrapper
      label={t('topPerformance', 'Top performance')}
      handleCheck={handleCheck}
      isChecked={bigWidgetsList[BigWidgetsName.topPerformance]}
      explanation={t('StandOutSessions', 'Stand out sessions')}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap={spacing(1)}
        mt={{ xs: spacing(2), md: spacing(6) }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
        >
          <Typography component="span" fontWeight={500} color={palette.grey[700]}>
            {t('mostActiveSession', 'Most active session')}:
          </Typography>
          <Typography component="span" fontWeight={500}>
            {mostActiveSession}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
        >
          <Typography component="span" fontWeight={500} color={palette.grey[700]}>
            {t('mostProfitableSession', 'Most profitable session')}:
          </Typography>
          <Typography component="span" fontWeight={500}>
            {mostProfitableSession}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
        >
          <Typography component="span" fontWeight={500} color={palette.grey[700]}>
            {t('leastProfitableSession')}:
          </Typography>
          <Typography component="span" fontWeight={500}>
            {leastProfitableSession}
          </Typography>
        </Box>
      </Box>
    </WidgetWrapper>
  )
}
